//uat
// export const baseUrl = "https://uathelp.tataplay.com/recharge";

//Prod
// export const baseUrl = "https://unifiedbot.tataplay.com/recharge";

//dev
// export const baseUrl = "https://uathelp.tataplay.com/recharge-dev";

// Beta
export const baseUrl = "https://unifiedbot.tataplay.com/beta";   